module.exports = __webpack_public_path__ + "assets/icon_appetizers.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icon_appetizers.png
 ** module id = 113
 ** module chunks = 1
 **/